import {
    DELEGATEE_UPDATED,
    DELEGATOR_UPDATED,
    DELETE_DELEGATEES,
    GET_DELEGATEE,
    GET_DELEGATOR,
    GET_PROFILE,
    PROFILE_UPDATED,
    UPDATE_DELEGATEES,
    UPDATE_DELEGATEES_RESPONSE,
    UPDATE_PROFILE,
    UPDATE_PROFILE_ERROR,
    USER_UPDATED
} from "./actionTypes";

export const userUpdated = user => {
    return {
        type: USER_UPDATED,
        payload: user
    };
};

export const profileUpdated = profile => {
    return {
        type: PROFILE_UPDATED,
        payload: profile
    };
};

export const getProfile = history => {
    return {
        type: GET_PROFILE,
        payload: {history}
    };
};

export const updateProfile = (id, data, history) => {
    return {
        type: UPDATE_PROFILE,
        payload: {id, data, history}
    };
};

export const updateProfileError = error => {
    return {
        type: UPDATE_PROFILE_ERROR,
        payload: error
    };
};

export const getDelegator = () => {
    return {
        type: GET_DELEGATOR,
        payload: {}
    };
};

export const getDelegatee = () =>{
    return {
        type: GET_DELEGATEE,
        payload: {}
    };
};

export const delegatorUpdated = delegator => {
    return {
        type: DELEGATOR_UPDATED,
        payload: delegator
    };
};

export const delegateeUpdated = delegatee => {
    return {
        type: DELEGATEE_UPDATED,
        payload: delegatee
    };
};

export const updateDelegatees = (delegatees, history) => {
    return {
        type: UPDATE_DELEGATEES,
        payload: {delegatees, history}
    };
};

export const deleteDelegatees = (ids, history) => {
    return {
        type: DELETE_DELEGATEES,
        payload: {ids, history}
    };
};

export const updateDelegateesResponse = message => {
    return {
        type: UPDATE_DELEGATEES_RESPONSE,
        payload: message
    };
};
